namespace TabAurous.Retail {
    export namespace POSApprovalReturnItemsService {
        export const baseUrl = 'Retail/POSApprovalReturnItems';

        export declare function Create(request: Serenity.SaveRequest<POSApprovalReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<POSApprovalReturnItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<POSApprovalReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/POSApprovalReturnItems/Create",
            Update = "Retail/POSApprovalReturnItems/Update",
            Delete = "Retail/POSApprovalReturnItems/Delete",
            Retrieve = "Retail/POSApprovalReturnItems/Retrieve",
            List = "Retail/POSApprovalReturnItems/List",
            CustomList = "Retail/POSApprovalReturnItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>POSApprovalReturnItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
